import { useNavigate } from "react-router-dom";
import Button from "@/components/base/Button";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-6">
          <i className="ri-error-warning-line text-primary-500 text-3xl" />
        </div>
        <h1 className="text-4xl font-bold text-foreground-900 mb-2">404</h1>
        <p className="text-lg text-foreground-600 mb-2">Página no encontrada</p>
        <p className="text-sm text-foreground-500 mb-8">
          La página que buscas no existe o fue movida. Verifica la URL o vuelve al inicio.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <i className="ri-arrow-left-line" /> Volver atrás
          </Button>
          <Button onClick={() => navigate("/dashboard")}>
            <i className="ri-home-line" /> Ir al dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}